import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/solutions",
        name: "solutions",
        component: () => import("@/components/solutions/_Solutions.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewSolutionsUI,
            breadcrumbs: {
                icon: "monitor-icon",
                paths: []
            },
            title: "navbar.solutions"
        }
    },
    {
        path: "/solutions/create",
        name: "createSolution",
        component: () => import("@/components/solutions/_SolutionForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateSolution,
            breadcrumbs: {
                icon: "monitor-icon",
                paths: [
                    ["/solutions", i18n.t("solution.title")]
                ]
            },
            title: "solution.createTitle"
        },
        props: true
    },
    {
        path: "/solutions/:solutionId/update",
        name: "updateSolution",
        component: () => import("@/components/solutions/_SolutionForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateSolution,
            breadcrumbs: {
                icon: "monitor-icon",
                paths: [
                    ["/solutions", i18n.t("solution.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/solutions/:solutionId/preview",
        name: "previewSolution",
        component: () => import("@/components/solutions/_SolutionPreview.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewSolutionsUI,
            layout: () => import("@/components/layouts/_BasicLayout.vue"),
            title: "common.preview"
        },
        props: true
    }
];
